import type { PaymentProfile, PaymentProfileInput } from "@boo/shared";
import { request } from "./apiClient";

export async function fetchPaymentProfiles(): Promise<PaymentProfile[]> {
  return request<PaymentProfile[]>("/payment-profiles");
}

export async function createPaymentProfile(
  payload: PaymentProfileInput,
): Promise<PaymentProfile> {
  return request<PaymentProfile>("/payment-profiles", {
    method: "POST",
    data: payload,
  });
}

export async function updatePaymentProfile(
  id: string,
  payload: Partial<PaymentProfileInput>,
): Promise<PaymentProfile> {
  return request<PaymentProfile>(`/payment-profiles/${id}`, {
    method: "PATCH",
    data: payload,
  });
}

export async function deletePaymentProfile(id: string): Promise<void> {
  await request<void>(`/payment-profiles/${id}`, { method: "DELETE" });
}

export async function uploadProfileQr(
  id: string,
  file: File,
): Promise<PaymentProfile> {
  const formData = new FormData();
  formData.append("file", file);
  return request<PaymentProfile>(`/payment-profiles/${id}/qr`, {
    method: "POST",
    data: formData,
  });
}

/**
 * The QR needs the auth header, so it is fetched as a blob for an <img>.
 * `version` busts the HTTP cache (the API allows 5 min) after a re-upload.
 */
export async function fetchProfileQrUrl(
  id: string,
  version = 0,
): Promise<string> {
  const blob = await request<Blob>(`/payment-profiles/${id}/qr`, {
    responseType: "blob",
    params: { v: version },
  });
  return URL.createObjectURL(blob);
}
